import React from 'react'

import ImageWithText from '../../components/ImageWithText'
import screenshotUrl from './screenshot.png'

const ReferralEngineScreen2: React.FC = () => (
  <ImageWithText
    imageUrl={screenshotUrl}
    text={
      <p>
        Referring a client is quick and compliant. Pick the firm, add the
        details, and a referral case is created—complete with updates, messages,
        and documents.
      </p>
    }
  />
)

export default ReferralEngineScreen2
